import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaCadenaComponent } from "app/features/componentes/firmacadena";

type Entity = models.InformacionCliente | null;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


/**
* Modal de edición para un InformacionCliente
*/
export class InformacionClienteModal extends React.PureComponent<Props> {

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;

        return (
            <kea.Modal
                buttons={[]}
                onClose={this.onCerrar}
                title="Información del cliente que recibio"
            >
                {
                    value != null ?
                        <div>
                            <kea.Text label="Cliente que recibio:" value={value.NombreCliente} readonly={true} />
                            <FirmaCadenaComponent label="Firma" value={value.FirmaUsuario} />
                        </div>
                        :
                        <div />
                }

            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/guia/informacionclientemodal.tsx